import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  card: null,
  showCard: null,
  toastMessage: null,
}

const showCardSlice = createSlice({
  name: 'showCard',
  initialState,
  reducers: {
    initCard(state, action) {
      state.card = action.payload.card
    },
    initShowCard(state, action) {
      state.showCard = action.payload.showCard
    },
    setToastMessage(state, action) {
      state.toastMessage = action.payload?.toastMessage
    },
    clearToastMessage(state) {
      state.toastMessage = null
    },
  },
})

export const { initCard, initShowCard, setToastMessage, clearToastMessage } = showCardSlice.actions

export const selectCard = (state) => state.showCard.card
export const selectShowCard = (state) => state.showCard.showCard
export const selectToastMessage = (state) => state.showCard.toastMessage

export default showCardSlice.reducer
